export const clinicNoteState = {
  isSpeechRecognizing: false,
  clinicNotesExpanded: true,
  clinicNotesTouched: false,
  clinicNoteSubmitting: false,
  clinicNoteSubmittingAndProcessing: false,
  clinicNoteSubmittingAndSigningAndProcessing: false,
  clinicNoteSubmittingAndSigningAndUnProcessing: false,
  clinicNotesEsig: false,
  clinicNotes: "",
  originalClinicNotes: "",
  reportFIN: "",
  originalReportFIN: "",
  clinicSignature: "",
  clinicNotesEsigDisabled: false,
  clinicMrn: "",
  clinicMrnTouched: false,
  clinicMrnSubmitting: false,
};
